import React, { useContext, useEffect } from "react";
import {
	Route,
	Routes,
	useLocation,
	useNavigate,
	useParams,
} from "react-router-dom";
import Schedule from "../Schedule/Schedule";
import Services from "../Services/Services";
import Confirmation from "../Confirmation/Confirmation";
import Login from "../Login/Login";
import Appointments from "../Appointments/Appointments";
import ConfirmedAppointment from "../ConfirmedAppointment/ConfirmedAppointment";
import Navbar from "../Navbar/Navbar";
import Header from "../Header/Header";
import { CreatorContext } from "../../contexts/CreatorContext";
import { IframeContext } from "../../contexts/IframeContext";

const BasePathRouter = () => {
	const { isInIframe } = useContext(IframeContext);
	const { creator } = useContext(CreatorContext);
	const navigate = useNavigate();
	const { basePath } = useParams();
	const location = useLocation();

	useEffect(() => {
		document.body.style.backgroundColor = creator?.backgroundColor || "#ffffff";
		// Only run this effect on the initial load (or reload)
		console.log(basePath);
		if (location.pathname !== `/${basePath}/`) {
			navigate(`/${basePath}/`);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<Navbar />
			<Routes>
				<Route path="/" element={<Services />} />
				<Route path="/schedule" element={<Schedule />} />
				<Route path="/confirmation" element={<Confirmation />} />
				<Route path="/login" element={<Login />} />
				<Route path="/appointments" element={<Appointments />} />
				<Route
					path="/appointment-confirmed"
					element={<ConfirmedAppointment />}
				/>{" "}
				{/* Nueva ruta */}
			</Routes>
		</>
	);
};

export default BasePathRouter;
